import { IConsultantSuiviSortieDesEffectifsRequestModel } from "./core/_models"
import { Form, Formik, FormikHelpers } from "formik"
import { toast } from "react-toastify"
import { AxiosError } from "axios"
import { IConsultantModel, IHttpErrorResponseModel } from "@common-models/*"
import { CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR } from "@common-constants/*"
import MyAlert from "@common-utils/MyAlert"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import React, { useState } from "react"
import { consultantSuiviSortieDesEffectifsRequest } from "./core/_requests"
import MyDateDayMonthYearField from "@common-utils/fields/MyDateDayMonthYearField"
import * as Yup from "yup"
import moment from "moment"

const ConsultantSuiviSortieDesEffectifs = ({ consultant, annulerCallback = () => {}, onSubmitCallback = () => {} }: IPropsModel) => {
     const [isUnderstood, setIsUnderstood] = useState(false)
     // Form schema
     const schema = Yup.object().shape({
          date: Yup.string().required().label(`"Date"`),
     })

     // Form initial values
     const initialValues: IConsultantSuiviSortieDesEffectifsRequestModel = {}

     // Handle submit
     function handleSubmit(values: IConsultantSuiviSortieDesEffectifsRequestModel, helpers: FormikHelpers<IConsultantSuiviSortieDesEffectifsRequestModel>) {
          helpers.setStatus(null)

          consultantSuiviSortieDesEffectifsRequest(consultant.id as number, values)
               .then(() => {
                    onSubmitCallback()
                    toast.success(`${consultant.prenomNom} ne fait plus partie de l'effectif dès le ${moment(values.date).format("dddd D MMMM YYYY")}.`, { autoClose: false })
               })
               .catch((e: AxiosError) => {
                    const error: IHttpErrorResponseModel = e.response?.data

                    // Set form errors
                    if (error?.code === CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR && error?.errors) {
                         for (const key in error.errors) helpers.setFieldError(key, error.errors[key])
                    }

                    // Set form global status and notify user using a toast
                    helpers.setStatus(error?.detail)
                    toast.error(error?.detail, { autoClose: false })

                    // Stop submit loader
                    helpers.setSubmitting(false)
               })
     }

     return (
          <>
               {!isUnderstood && (
                    <>
                         <div className={"mb-4 fs-3 fw-bold text-center"}>Veuillez lire attentivement les deux notices</div>
                         <MyAlert type={"danger"} classNames={"mb-4"} title={"Notice 1"}>
                              Veuillez vous assurer que tous les événements ont été ajoutés avant la sortie du collaborateur. Une fois la sortie effectuée, il ne sera plus possible
                              d'ajouter d'autres événements.
                         </MyAlert>
                         <MyAlert type={"info"} classNames={"mb-4"} title={"Notice 2"}>
                              Indiquez la date de sortie prévue ou mentionnée sur le certificat de travail ou le solde de tout compte.
                         </MyAlert>

                         <div className="text-center">
                              <span className={"btn btn-outline btn-outline-primary"} onClick={() => setIsUnderstood(true)}>
                                   PROCÉDER À LA SORTIE DU COLLABORATEUR
                                   <i className={"fas fa-check-circle ms-2"} />
                              </span>
                         </div>
                    </>
               )}

               {isUnderstood && (
                    <Formik initialValues={initialValues} validationSchema={schema} onSubmit={handleSubmit}>
                         {helpers => {
                              console.log(helpers.errors)
                              return (
                                   <Form noValidate autoComplete="off">
                                        {helpers.status && (
                                             <MyAlert type={"danger"} classNames={"mb-4"}>
                                                  {helpers.status}
                                             </MyAlert>
                                        )}

                                        <div className="row">
                                             <label className="col-lg-4 col-form-label fw-bold fs-6 required">Date de prise d'effet</label>

                                             <div className="col-lg-8">
                                                  <MyDateDayMonthYearField
                                                       name={"date"}
                                                       value={helpers.values.date}
                                                       isInvalid={!!helpers.errors.date}
                                                       onChange={val => helpers.setFieldValue("date", val)}
                                                       placeholder={"Date de prise d'effet"}
                                                       classNames={"rounded-0 rounded-start"}
                                                       disabledWeekends={true}
                                                  />
                                                  {helpers.errors.date && <div className={"text-danger"}>{helpers.errors.date}</div>}
                                             </div>
                                        </div>

                                        <div className="separator separator-dashed my-4" />

                                        {/* Submit button */}
                                        <div className={"d-flex justify-content-end"}>
                                             <button
                                                  className={"btn btn-sm btn-outline btn-outline-primary d-inline-flex align-items-center me-2"}
                                                  type={"button"}
                                                  onClick={annulerCallback}
                                                  disabled={helpers.isSubmitting}
                                             >
                                                  Annuler
                                             </button>
                                             <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                                  {!helpers.isSubmitting ? <>Valider</> : <MySimpleSpinner size={"sm"} />}
                                             </button>
                                        </div>
                                   </Form>
                              )
                         }}
                    </Formik>
               )}
          </>
     )
}

interface IPropsModel {
     consultant: IConsultantModel
     annulerCallback?: () => void
     onSubmitCallback?: () => void
}

export default ConsultantSuiviSortieDesEffectifs
